import client from './client';

export interface CreditPackage {
  name: string;
  credits: number;
  price: number;
  perUnit: number;
}

export interface CreditOrder {
  orderId: string;
  packageName: string;
  amount: number;
  credits: number;
}

export interface CreditInfo {
  licenseId: string;
  balance: number;
}

export async function getCreditInfoByStore(storeId: string): Promise<CreditInfo> {
  const response = await client.get<CreditInfo>(`/api/credits/store/${storeId}/info`);
  return response.data;
}

export async function getCreditPackages(): Promise<CreditPackage[]> {
  const response = await client.get<CreditPackage[]>('/api/credits/packages');
  return response.data;
}

export interface ActivePaymentMethods {
  card: boolean;
  kakaopay: boolean;
  /** 카드 결제는 가능하지만 심사 진행 중이라 거절될 수 있는 카드사 (사용자 친화 라벨, 예: "신한") */
  pendingCards: string[];
}

/**
 * 활성 결제수단 조회 (카드사 심사 진행 중이면 card=false)
 */
export async function getActivePaymentMethods(): Promise<ActivePaymentMethods> {
  const response = await client.get<ActivePaymentMethods>('/api/credits/payment-methods');
  return response.data;
}

export async function createCreditOrder(
  licenseId: string,
  packageName: string,
): Promise<CreditOrder> {
  const response = await client.post<CreditOrder>(`/api/credits/${licenseId}/order`, {
    packageName,
  });
  return response.data;
}

export async function confirmCreditOrder(
  licenseId: string,
  packageName: string,
  paidAmount: number,
): Promise<any> {
  const response = await client.post(`/api/credits/${licenseId}/confirm`, {
    packageName,
    paidAmount,
  });
  return response.data;
}

export interface InicisFormData {
  mid: string;
  oid: string;
  price: number;
  timestamp: string;
  use_chkfake: string;
  signature: string;
  mKey: string;
  verification: string;
  goodname: string;
  buyername: string;
  buyertel: string;
  buyeremail: string;
  returnUrl: string;
  closeUrl: string;
  gopaymethod: string;
  acceptmethod: string;
  currency: string;
  version: string;
  scriptUrl: string;
  licenseId: string;
  packageName: string;
  credits: number;
}

export async function prepareInicisPayment(
  licenseId: string,
  packageName: string,
  buyer: { name?: string; tel?: string; email?: string },
): Promise<InicisFormData> {
  const response = await client.post<InicisFormData>(
    `/api/credits/${licenseId}/inicis/prepare`,
    {
      packageName,
      buyerName: buyer.name,
      buyerTel: buyer.tel,
      buyerEmail: buyer.email,
      // KG이니시스: returnUrl 도메인 == 호출 페이지 도메인 필수
      origin: window.location.origin,
    },
  );
  return response.data;
}

export interface CreditHistoryItem {
  id: string;
  licenseId: string;
  creditType: string; // SIGNUP_BONUS | PURCHASE | ADMIN_GRANT
  totalCredits: number;
  usedCredits: number;
  remainingCredits: number;
  packageName: string | null;
  amount: number | null;
  paymentId: string | null;
  memo: string | null;
  createdAt: string;
  expiresAt: string | null;
}

export async function getCreditHistory(licenseId: string): Promise<CreditHistoryItem[]> {
  const response = await client.get<CreditHistoryItem[]>(
    `/api/credits/${licenseId}/history`,
  );
  return response.data;
}
